@if (audit) {
    <div class="desktop-container">
        <div class="min-w-0">
            <span class="intro min-w-0">
                <div class="min-w-0">
                    <h3 class="p-0 m-0">{{ title }}</h3>
                    <app-assigned-item-meta class="text-xs mt-1" [meta]="meta"></app-assigned-item-meta>
                </div>
            </span>
        </div>
        <p-tag [styleClass]="badge.styleClass" [value]="badge.label"></p-tag>
        <app-flight-card-cta
            class="w-full"
            [flight]="audit"
            [type]="'audit'"
            [canBeArchived]="true"
            [asListRow]="true">
        </app-flight-card-cta>
    </div>

    <div class="mobile-container" (click)="$event.stopPropagation()">
        <app-flight-card-mobile [content]="'flex'">
            <ng-container title>{{ title }}</ng-container>
            <ng-container subtitle>
                <div class="mt-2">
                    <p-tag [styleClass]="badge.styleClass" [value]="badge.label"></p-tag>
                </div>
            </ng-container>
            <ng-container content>
                <app-assigned-item-meta class="text-sm" [meta]="meta"></app-assigned-item-meta>
            </ng-container>
            <ng-container actions>
                <app-flight-card-cta
                    class="w-full"
                    actions
                    [flight]="audit"
                    [type]="'audit'"
                    [canBeArchived]="true"
                    [asListRow]="true">
                </app-flight-card-cta>
            </ng-container>
        </app-flight-card-mobile>
    </div>
}
